/**
 * Line icons for the four product pillars -- Design System v1.0, section 01.
 *
 * 1.5 px stroke, rounded caps and joins, set in a 48 px Sable circle.
 * Never filled, never two-tone.
 */

export type PillarIconName = 'qr' | 'orders' | 'menu' | 'report';

interface PillarIconProps {
  name: PillarIconName;
  className?: string;
}

const PATHS: Record<PillarIconName, JSX.Element> = {
  qr: (
    <>
      <rect x="4" y="4" width="6" height="6" rx="1.5" />
      <rect x="14" y="4" width="6" height="6" rx="1.5" />
      <rect x="4" y="14" width="6" height="6" rx="1.5" />
      <path d="M14 14h2.5v2.5M20 14v.01M17 20h3v-3M14 19v1" />
    </>
  ),
  orders: (
    <>
      <path d="M4 17h16" />
      <path d="M5.5 17a6.5 6.5 0 0 1 13 0" />
      <path d="M12 8.5V7M10.5 7h3" />
      <path d="M3 20h18" />
    </>
  ),
  menu: (
    <>
      <rect x="5" y="3.5" width="14" height="17" rx="2" />
      <path d="M8.5 8h7M8.5 12h7M8.5 16h4" />
    </>
  ),
  report: (
    <>
      <path d="M4 20h16" />
      <path d="M7 16v-4M12 16V7M17 16v-6" />
    </>
  ),
};

export function PillarIcon({ name, className }: PillarIconProps) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {PATHS[name]}
    </svg>
  );
}
